import React from "react";
import { Select } from "../../../controls";
import { useContext } from "react";
import { AppContext } from "../../../App";

const CartProdPriceInp = ({ item, setCartItems }) => {
  const { org } = useContext(AppContext);
  const handleInpChg = (e) => {
    var newPriceId = e.target.value;
    setCartItems((cartItem) => [
      ...cartItem.map((prod) => {
        if (item.prices && prod.productId === item.productId) {
          var priceDtl = item.prices.find((j) => j.id === newPriceId);
          return {
            ...prod,
            price: priceDtl.price.toFixed(org.decimal),
            priceId: priceDtl.id,
          };
        }
        return {
          ...prod,
        };
      }),
    ]);
  };

  return (
    <div>
      <Select
        value={item.priceId}
        onChange={handleInpChg}
        options={item.prices || []}
        size="small"
        variant="outlined"
        className="d-flex a-end"
        sx={{
          "& .MuiInputBase-root": {
            minWidth: "115px",
            fontSize: "0.95rem", // slightly larger text
            paddingLeft: "2px",
            fontWeight: "600",
            color: "var(--gray-color)",
            boxShadow: "var(--shadow-xs)",
          },
          "& .MuiInputBase-input": {
            padding: "4px 0px 2px 6px", // reduced padding
          },
          "& .MuiSelect-select": {
            paddingRight: "28px", // maintain space for icon
          },
          "& .MuiSelect-icon": {
            fontSize: "19px",
            top: "calc(50% - 9.5px)",
          },
        }}
      />
    </div>
  );
};

export default CartProdPriceInp;
